/*
  La Goka: bloque "Envío gratis" de la página de producto.
  Calcula cuánto falta para el envío gratis con el carrito actual más este producto
  (precio de la presentación elegida por la cantidad) y se actualiza cuando cambia
  el carrito, la presentación o la cantidad, también la que elige la app de paquetes.
*/
if (!window.Eurus.loadedScript.has('goka-producto.js')) {
  window.Eurus.loadedScript.add('goka-producto.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('gokaEnvio', (config) => ({
        threshold: config.threshold,
        price: config.price,
        cartTotal: config.cartTotal,
        inCart: config.inCart,
        quantity: 1,

        init() {
          const section = this.$root.closest('.shopify-section') || document;
          const update = () => setTimeout(() => this.readQuantity(section), 50);

          section.addEventListener('click', update);
          section.addEventListener('input', update);
          section.addEventListener('change', update);
          document.addEventListener('eurus:cart:items-changed', () => this.refreshCart());
          document.addEventListener(`eurus:product-page-variant-select:updated:${config.sectionId}`, (event) => {
            const source = event.detail.html?.querySelector('[data-goka-envio-price]');
            if (source) this.price = Number(source.dataset.gokaEnvioPrice);
          });
        },

        readQuantity(section) {
          const values = [...section.querySelectorAll('input[name="quantity"]')].map((input) => parseInt(input.value, 10) || 1);
          this.quantity = Math.max(1, ...values);
        },

        async refreshCart() {
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
            const cart = await response.json();
            this.cartTotal = cart.total_price;
            this.inCart = cart.items.some((item) => item.product_id === config.productId);
          } catch (error) {
            console.error(error);
          }
        },

        get basis() {
          return this.cartTotal + (this.inCart ? 0 : this.price * this.quantity);
        },

        get remaining() {
          return Math.max(this.threshold - this.basis, 0);
        },

        get percent() {
          return Math.min(Math.floor((this.basis * 100) / this.threshold), 100);
        },

        get remainingText() {
          const money = Alpine.store('xHelper').formatMoney(this.remaining, config.moneyFormat).replace(/[.,]00(?=\D*$)/, '');
          return config.remainingTemplate.replace('{monto}', money);
        },
      }));
    });
  });
}
